import React from 'react';
import { parseProps } from './@uteis';

import '../../assets/dsgov/css/components/textarea.css';
import CommonsStyle from './@Commons.module.css';
import FieldFeedback from './FieldFeedback';

const TextArea = (_props) => {
  const props = parseProps(_props);

  const label = 'label' in props ? <label htmlFor="textarea">{props.label}</label> : null;
  const rows = 'rows' in props ? props.rows : 3;
  const cols = 'cols' in props ? props.cols : 10;

  const attr = {
    valid: props.valid,
    invalid: props.invalid,
  };

  let feedback = null;
  if ('feedback_message' in props) {
    feedback = <FieldFeedback {...props} />;
  }
  if ('feedback' in props) {
    feedback = props.feedback;
  }

  return (

    <div className="br-textarea" {...attr} style={{ width: "100%" }}>
      {label}
      <textarea
        style={{ height: props.height }}
        id={props.id}
        placeholder={props.placeholder}
        maxLength={props.maxLength ? props.maxLength : null}
        rows={rows}
        cols={cols}
        onBlur={props.onBlur}
        onChange={props.onChange}
        value={props.value}
        disabled={props.disabled || false}
      />
      {props.info
        ? (
          <span className={CommonsStyle.Info}>
            {props.info}
          </span>
        ) : null}
      {feedback}
    </div>

  );
};

export default TextArea;
